import { mockConfig } from '@/mocks/mockConfig';
import ObsidianApi from 'obsidian-api';
import type { IAppConfig } from '@/typescript/interfaces/IAppConfig';

// Reads the runtime config from Obsidian and falls back to mockConfig
// when the host isn't wired (dev, tests, standalone). Isolated so the
// composition root doesn't reach into the ObsidianApi singleton.
function loadRuntimeConfig(): IAppConfig {
    const config = ObsidianApi.$getConfig() as IAppConfig;
    if (Object.keys(config).length === 0) {
        return mockConfig();
    }
    return config;
}

export { loadRuntimeConfig };
